import { api } from "@/APIRequests";
import type { PatientStatus, UUID } from "@/core/types";
import type { UpdatePatientStatusResponse } from "@/APIRequests/providerTyped";

export type UpdatePatientStatusVariables = {
  patientId: UUID;
  providerName?: string;
  reason?: string;
  status: PatientStatus;
};

export async function updatePatientStatus({
  patientId,
  providerName,
  reason,
  status,
}: UpdatePatientStatusVariables): Promise<UpdatePatientStatusResponse> {
  return api.providerTyped.update_patient_status({
    data: { providerName, reason, status, username: patientId },
    patientId,
  });
}
